import axios from 'axios';
import _ from 'lodash';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';




const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export const svLoadReguserallBegin = () => dispatch => {
    dispatch({
        type:'GET_REGUSERALL_BEGIN'
        
    })
}


export const geLoadReguserallSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_REGUSERALL_SUCCESS',
        payload: data
    })
}

export const getLoadReguserallError = (e) =>dispatch => {
    dispatch({
        type:'GET_REGUSERALL_ERROR',
        error:e
    })
}



export function deleteReguser_dbworkingsv(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadReguserallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/reguserDelete`
        const bodyDelete = {
            "id": (nameQParam? nameQParam:3)
           }

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/regusersListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
        axios.all([
            axios.post(urlDelete, bodyDelete, {headers:headers}),
            axios.post(url,body, {headers:headers})
        ])
        .then(
            axios.spread((rd,r)=>{

                if(rd['status']  == 200){
                  

                   
                    if(r.data.length>0){
                        const ar = r.data
                        const comData = { my_data_addresslist:  ar }
    
                        dispatch(geLoadReguserallSuccess(comData))
                    }
                    else {
                        const comData = { my_data_addresslist: []}
                        dispatch(getLoadReguserallError(comData))
                    }

                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadReguserallError(comData))
                }

            })
        )
        
         /* 
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_addresslist:  ar }

                   
                    dispatch(geLoadAddressallSuccess(comData))
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadAddressallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadAddressallError(e))
        )
        */
    }

}

export function loadReguserList(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadReguserallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/regusersListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    //customerId
                    ar.map( (o,idx)=>{
                        o['id'] = o['customerId']
                    });
                    const comData = { my_data_addresslist:  ar }

                    //we are lowercase aleadt

                    /*
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data_addresslist.push(sod)
                    });

                   */
                    dispatch(geLoadReguserallSuccess(comData))
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadReguserallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReguserallError(e))
        )
    }
}




export function deleteReguser(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadReguserallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDelete`
        const bodyDelete = {
            "id": (nameQParam? nameQParam:3)
           }

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/regusersListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
       
        
         
        axios.post(urlDelete, bodyDelete, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_addresslist:  ar }

                   
                    dispatch(geLoadReguserallSuccess(comData))
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadReguserallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReguserallError(e))
        )
        
    }

}
